var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutubeBlue = function SvgYoutubeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.481)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.759,
    cy: 25.759,
    r: 25.759,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M35.149 15.04H18.032a5.571 5.571 0 0 0-5.651 5.567v10.055a5.565 5.565 0 0 0 5.65 5.65H35.15c1.491 0 2.92-.597 3.966-1.66a5.562 5.562 0 0 0 1.601-3.99V20.607a5.567 5.567 0 0 0-5.567-5.567zM23.1 30.33v-9.307a.915.915 0 0 1 1.413-.831l7.81 4.653a.995.995 0 0 1 .001 1.662l-7.811 4.653a.915.915 0 0 1-1.413-.83z"
  }))));
};

export default SvgYoutubeBlue;